import { TextField } from '@mui/material';

const InputComponent = ({ ...other }) => <div {...other} />;

const OutlinedDiv = ({
  InputProps,
  children,
  InputLabelProps,
  label,
  ...other
}) => {
  return (
    <TextField
      {...other}
      variant='outlined'
      label={label}
      multiline
      slotProps={{
        inputLabel: {
          shrink: true,
          ...InputLabelProps,
        },
        input: {
          ...InputProps,
        },
        htmlInput: {
          children: children,
        },
      }}
      slots={{
        input: InputComponent,
      }}
    />
  );
};

export default OutlinedDiv;
